import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Pagination from '../../components/Pagination';
import Loader from '../../components/Loader';
import EditableTable from "./Table";
import Modal from "../../components/Modal"
import ChangeLog from "../../components/ChangeLog";
import { fetchPanelUser, updatePanelUser , setPageSize } from "@/slices/panelUserSlice";
import { fetchCountryList } from "../../slices/LocationSlice/countrySlice";
import { fetchGenderList } from "../../slices/genderSlice";
import SimplePagination from "@/components/SimplePagination";
import PanelUserSearch from "@/components/PanelUserSearch";
import PageSizeSelector from "@/components/PageSizeSelector";
import AddUserBlackList from "./AddUserBlackList";
import AddUserUnBlacklist from "./AddUserUnBlacklist";
import AddRewardPoi from "./AddRewardPoi";


function PanelUser() {
  const dispatch = useDispatch();
  const { panelUserList , currentPage, totalPages, status , search , pageSize } = useSelector((state) => state.panelUser);

  const {countryList} = useSelector((state) => state.countryList);
  const {genderList} = useSelector((state)=>state.genderList);

  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});

  const headers = panelUserList?.result?.length > 0 ? Object.keys(panelUserList?.result[0]).filter((key) => key !== 'id') : [];
  const editableFields = ['title','is_active','name','email','gender','country','dateOfBirth','is_blackList']; // Define editable fields

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog,setCurrentLog] = useState([]);
  const [addPageDis, setAddPageDis] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const [searchInput, setSearchInput] = useState(search || "");

   const [showBlacklistModal, setShowBlacklistModal] = useState(false);
   const [showUnBlacklistModal, setShowUnBlacklistModal] = useState(false);
   const [showPoiModal, setShowPoiModal] = useState(false);


  const [selectedUser, setSelectedUser] = useState(null);

  const isSearching = searchInput && searchInput.trim() !== "";
  const hasData = panelUserList?.result?.length > 0;

  // console.log(panelUserList?.result , "hasdata")

  useEffect(() => {
  setSearchInput(search || "");
}, [search]);


  useEffect(() => {
    dispatch(fetchPanelUser({ page: 1, search}));
    dispatch(fetchCountryList());
    dispatch(fetchGenderList());
  }, [dispatch  ]);

 
  // ✅ Debounced search (MAIN CONTROL)
  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(fetchPanelUser({ page: 1, search: searchInput }));
    }, 800);

    return () => clearTimeout(timer);
  }, [searchInput]);

    // ✅ Page change
    useEffect(() => {
      dispatch(fetchPanelUser({ page: currentPage, search }));
    }, [currentPage]);


  // ✅ Page size change
const handlePageSizeChange = (size) => {
    dispatch(setPageSize(size)); // update slice
    dispatch(fetchPanelUser({ page: 1, search }));
  }; 

const onBlacklistClick = (user) => {
  setSelectedUser(user);
  setShowBlacklistModal(true);
 };


const onUnBlacklistClick = (user) =>{
   setSelectedUser(user);
  setShowUnBlacklistModal(true);
}

const onAddRewardPoi = (user) =>{
   setSelectedUser(user);
   setShowPoiModal(true)
} 

  if (status === "loading") {
    return (
      <div className="w-full pt-20 flex justify-center">
        <Loader />
      </div>
    );
  }

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = panelUserList?.result?.find((user) => user.id === rowId);
    setEditedData(rowData);
  };


  const handleSave = async () => {
    const { id, email, name, dateOfBirth, is_active, gender, country} = editedData;
    const updatedData = {id, email, name, dateOfBirth, is_active, country, gender};

    const resp = await dispatch(updatePanelUser(updatedData));
    if (!resp.error) {
      setEditRowId(null);
      dispatch(fetchPanelUser(currentPage));
    }
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleChange = (e, field,val) => {
      if(['status','active','is_active','is_blackList'].includes(field)){
        setEditedData((prev) => ({
          ...prev,
          [field]:!val,
        }));
      }else{
        setEditedData((prev) => ({
          ...prev,
          [field]:e.target.value,
        }));
      }
  };

  const handleLog = (id)=>{
    const logData = panelUserList.Change_Log.filter((f)=>f.id===id)[0]?.oldTrack;
    setCurrentLog(logData)
    openModal()
  }

  return (
    <div className="flex flex-col items-center p-6 pt-14">
      <h1 className="text-xl m-4 font-semibold">Panel User</h1>


      <PanelUserSearch  
      value={searchInput}
      onChange={setSearchInput}
      />
    <div className="w-full flex items-center flex-col">
    <div className="max-w-[95%]">
        {hasData ? (
    <EditableTable
      headers={headers}
      rows={panelUserList?.result || []}
      editRowId={editRowId}
      editedData={editedData}
      handleEdit={handleEdit}
      handleSave={handleSave}
      handleCancel={handleCancel}
      handleChange={handleChange}
      handleLog={handleLog}
      editableFields={editableFields}
      countryList={countryList}
      genderList={genderList}
      onBlacklistClick={onBlacklistClick} 
      onUnBlacklistClick ={onUnBlacklistClick} 
      onAddRewardPoi = {onAddRewardPoi}
    />
  ) : (
    <div className="w-full flex flex-col items-center justify-center py-20 text-gray-500">

      {/* Icon */}
      <div className="text-5xl mb-3">🔍</div>

      {/* Message */}
      {searchInput ? (
        <>
          <p className="text-lg font-medium">No results found</p>
          <p className="text-sm mt-1">
            for "<span className="font-semibold">{searchInput}</span>"
          </p>
        </>
      ) : (
        <>
          <p className="text-lg font-medium">No Data Available</p>
          <p className="text-sm mt-1">
            There are no users to display
          </p>
        </>
      )}

    </div>
  )}
    </div>
     
 {!(isSearching && !hasData) && (
    <div className="flex mt-4 items-center justify-between w-11/12">   
    <PageSizeSelector
      pageSize={pageSize}
      setPageSize={handlePageSizeChange}
    />
   
  <SimplePagination
    currentPage={currentPage}
    setCurrentPage={(page) =>
      dispatch(fetchPanelUser({ page, search : searchInput }))
    }
    totalPages={totalPages}
  />

    </div> 
   )}
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog}/>}
      />

    <Modal
        isOpen={showBlacklistModal} 
         title="Add user black list"
        onClose={() => setShowBlacklistModal(false)}
         content={
        <AddUserBlackList
          onClose={() => setShowBlacklistModal(false)}
          user={selectedUser}
        />}
     />

     <Modal
        isOpen={showUnBlacklistModal}
         title="Add user Unblock list"
        onClose={() => setShowUnBlacklistModal(false)}
         content={
        <AddUserUnBlacklist
          onClose={() => setShowUnBlacklistModal(false)}
          user={selectedUser}
        />}
     />

      <Modal
        isOpen={showPoiModal}
         title="Add Poi"
        onClose={() => setShowPoiModal(false)}
         content={
        <AddRewardPoi
          onClose={() => setShowPoiModal(false)}
          user={selectedUser}
        />}
     />
    </div>
    </div>
  );
}

export default PanelUser;